<template>
  <div>
    <v-breadcrumbs class="systock-breadcrump" dark>
      <v-breadcrumbs-item>{{
        `CONTROLE DE ACESSO / ${breadcrumb}`
      }}</v-breadcrumbs-item>
    </v-breadcrumbs>
    <v-card flat class="pa-1">
      <v-tabs centered>
        <v-tab @click="breadcrumb = 'USUÁRIOS'">
          <v-icon left>mdi-account</v-icon>
          Usuários
        </v-tab>
        <v-tab @click="breadcrumb = 'PERFIL'">
          <v-icon left>mdi-account-details</v-icon>
          Perfil
        </v-tab>
        <v-tab @click="breadcrumb = 'PERMISSÕES'">
          <v-icon left>mdi-account-key</v-icon>
          Permissões
        </v-tab>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cadastro-usuario :filtrar_admin="true"></cadastro-usuario>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <cadastro-perfil :filtrar_admin="true"></cadastro-perfil>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item class="ma-0">
          <v-card flat>
            <v-card-text class="pa-0">
              <Permissoes :filtrar_admin="true"></Permissoes>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>
<script>
import cadastroUsuario from "../acl/AclUsuario";
import cadastroPerfil from "../acl/AclPerfis";
import Permissoes from "./Permissoes";

export default {
  components: {
    cadastroUsuario,
    cadastroPerfil,
    Permissoes,
  },
  name: "Cadastros",

  data: () => ({ breadcrumb: "USUÁRIOS" }),

  created() {
    this.Helpers.verificarToken();
  },
};
</script>

<style>
/*
 **   ALTURA DINAMICA EM DIFERENTES TAMANHOS DE TELAS
 */

@media (max-height: 10000px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 610px !important;
  }
}

@media (max-height: 1040px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 610px !important;
  }
}

@media (max-height: 940px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 560px !important;
  }
}

@media (max-height: 900px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 510px !important;
  }
}

@media (max-height: 850px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 460px !important;
  }
}

@media (max-height: 800px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 410px !important;
  }
}

@media (max-height: 750px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 360px !important;
  }
}

@media (max-height: 700px) {
  .tabela-responsiva .v-data-table__wrapper {
    height: 310px !important;
  }
}

.tabela-responsiva .v-data-table__wrapper {
  overflow: auto !important;
}
</style>
